package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_03_22_Day_5() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Zolnur departs, telling the heroes that they should soon meet Korvis Whisperclaw.  As the heroes head Northwest, they see more rice fields, and they start to see the edges of the Greatmarsh. The air smells damp. As they continue, the pathway narrows with more tree and shrub overgrowth.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes stumble upon a male elf, talking to a very big green toad creature. The conversation seems quite heated and quickly becomes even more heated when the Slaad cast several fireball spells. The Slaad hurt the livestock, so the heroes show them no mercy.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Korvis introduces himself to the heroes. He plans to escort the heroes through the marsh. Korvis heals Aloysius, endearing himself to the Friends of the Forest.")
    }
}
